import { render, staticRenderFns } from "./FormFieldsContainer.vue?vue&type=template&id=42db5434&scoped=true&"
import script from "./FormFieldsContainer.vue?vue&type=script&lang=ts&"
export * from "./FormFieldsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FormFieldsContainer.vue?vue&type=style&index=0&id=42db5434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db5434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42db5434', component.options)
    } else {
      api.reload('42db5434', component.options)
    }
    module.hot.accept("./FormFieldsContainer.vue?vue&type=template&id=42db5434&scoped=true&", function () {
      api.rerender('42db5434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Form/FormFieldsContainer.vue"
export default component.exports